var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAgreedActionsStranding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 11,
    viewBox: "0 0 22 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0954503 10.4344C-0.138575 9.94742 0.0725314 9.37124 0.566969 9.1475L10.5763 4.61817L20.5856 0.0888394C21.08 -0.1349 21.6705 0.0785326 21.9045 0.565554C22.1386 1.05257 21.9275 1.62876 21.433 1.8525L1.41445 10.9112C0.920011 11.1349 0.329475 10.9215 0.0954503 10.4344Z",
    fill: "#009C8D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9354 7.39242L20.5747 9.11877C21.1096 9.25786 21.6594 8.94982 21.8027 8.43077C21.946 7.91171 21.6286 7.37818 21.0937 7.2391L16.7629 6.11298L13.9354 7.39242Z",
    fill: "#204BE1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72265 3.76232L1.72396 2.20253C1.18908 2.06345 0.639291 2.37148 0.49597 2.89054C0.352649 3.40959 0.670071 3.94312 1.20495 4.0822L4.89524 5.04176L7.72265 3.76232Z",
    fill: "#204BE1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgreedActionsStranding);
export default __webpack_public_path__ + "static/media/agreed-actions-stranding.6dbb6dc2932ad52a278c7081b1a57645.svg";
export { ForwardRef as ReactComponent };